import HelpdeskGraphQL from "./HelpdeskGraphQL";
import axios from "axios";
import RichpanelAxios from "./Axios";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 5, retryDelay: axiosRetry.exponentialDelay, retryCondition: ()=>{ return true } });
class Tenant extends HelpdeskGraphQL {

    static async syncMessenger(data) {
        return await axios({
            url: this.url + '/sync_messenger',
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
            },
            responseType: 'json',
            data: {
                data
            }
        })
    }

    static async getPropertiesData() {
        return await RichpanelAxios()({
            url: this.url + '/get-props-data',
            method: 'GET',
        })
    }
}

export default Tenant;